import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
export const Accordion = ({ type = 'single', defaultValue = type === 'single' ? 0 : [], children, className = '', onAccordionToggle, }) => {
    const [openItems, setOpenItems] = useState(() => {
        if (type === 'single') {
            return typeof defaultValue === 'number' ? [defaultValue] : [];
        }
        return Array.isArray(defaultValue) ? defaultValue : [];
    });
    const handleItemToggle = (itemValue) => {
        if (type === 'single') {
            setOpenItems(openItems.includes(itemValue) ? [] : [itemValue]);
            onAccordionToggle === null || onAccordionToggle === void 0 ? void 0 : onAccordionToggle(itemValue, !openItems.includes(itemValue));
        }
        else {
            setOpenItems(openItems.includes(itemValue)
                ? openItems.filter((item) => item !== itemValue)
                : [...openItems, itemValue]);
        }
    };
    const renderChildren = () => {
        return React.Children.map(children, (child, itemValue) => {
            if (!React.isValidElement(child))
                return null;
            return React.cloneElement(child, Object.assign(Object.assign({}, child.props), { isOpen: openItems.includes(itemValue), onToggle: () => handleItemToggle(itemValue) }));
        });
    };
    return _jsx("div", { className: `flex flex-col gap-2 ${className}`, children: renderChildren() });
};
